import { Navigate, Outlet, useLocation } from 'react-router'

import { useMe } from '@/auth/queries'

export function ProtectedRoute() {
  const me = useMe()
  const location = useLocation()

  if (me.isPending) {
    return (
      <div
        className="flex min-h-screen items-center justify-center"
        role="status"
        aria-label="Checking your session"
      >
        <div className="border-muted-foreground/30 border-t-foreground h-8 w-8 animate-spin rounded-full border-4" />
      </div>
    )
  }

  if (me.isError || !me.data) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return <Outlet />
}
